export default __webpack_public_path__ + "static/media/selected-horizontal-split.3821483c.svg";